import React from "react";
import { Mutation } from "react-apollo";
import Button from "@streeteasy/design-system/deprecated/Button";
import Input from "@streeteasy/design-system/deprecated/Input";
import Text from "@streeteasy/design-system/deprecated/Text";
import XButton from "@streeteasy/design-system/deprecated/XButton";
import { camelCase, mapKeys } from "lodash";
import { func, shape, string } from "prop-types";

import { setPasswordGA } from "../../../../analytics/ga";
import SET_PASSWORD from "../../../../mutations/set_password";
import { triggerSaveDataGA } from "../../../Analytics/analytics";
import {
  ModalButton,
  ModalHeading,
  ModalInput,
  ModalText,
  ModalTitle,
  SetPasswordWrapper,
  XButtonWrapper
} from "../../styled";

class SetPassword extends React.Component {
  static defaultProps = {
    formError: ""
  };

  static propTypes = {
    form: shape({
      password: string
    }).isRequired,
    formError: string,
    handleCloseModal: func.isRequired,
    handleInputChange: func.isRequired,
    handleMutationError: func.isRequired,
    handleRenderError: func.isRequired
  };

  // GA starts
  componentDidMount() {
    setPasswordGA.setPasswordModalOpens("email", "registered");
  }
  // GA ends

  handleCompleted = data => {
    // GA starts
    const analyticsData = mapKeys(
      data.set_password.analytics_data,
      (value, key) => camelCase(key)
    );
    analyticsData.source = "email";

    triggerSaveDataGA();

    setPasswordGA.userSubmitsValidPassword("email", analyticsData.flow);
    localStorage.setItem("analytics", JSON.stringify(analyticsData));
    // GA ends

    window.location.reload();
  };

  handleSubmit = mutationQuery => {
    mutationQuery({
      variables: {
        password: this.props.form.password
      }
    });
  };

  render() {
    return (
      <SetPasswordWrapper>
        <ModalHeading>
          <ModalTitle type="primarySm">Let’s set a password</ModalTitle>
          <XButtonWrapper>
            <XButton onClick={this.props.handleCloseModal} />
          </XButtonWrapper>
        </ModalHeading>
        <ModalText>
          <Text type="sm">That way, you can sign in more easily next time</Text>
        </ModalText>
        <Mutation
          mutation={SET_PASSWORD}
          onCompleted={this.handleCompleted}
          onError={this.props.handleMutationError}
        >
          {mutationQuery => (
            <form
              onSubmit={e => {
                this.handleSubmit(mutationQuery);
                e.preventDefault();
              }}
            >
              <ModalInput>
                <Input
                  autoFocus
                  isInvalid={this.props.formError}
                  name="password"
                  onChange={this.props.handleInputChange}
                  placeholder="Password (at least 5 characters)"
                  type="password"
                />
              </ModalInput>
              {this.props.handleRenderError()}
              <ModalButton>
                <Button theme="primary" type="submit">
                  Create
                </Button>
              </ModalButton>
            </form>
          )}
        </Mutation>
      </SetPasswordWrapper>
    );
  }
}

export default SetPassword;
